export default "__VITE_ASSET__Jb1eqimL__"